import { depthToAmbient } from "../physics/pressure.js";
import type { GasMix } from "../types.js";

const NOAA_TABLE: ReadonlyArray<readonly [number, number]> = [
  [0.50, 720],
  [0.60, 720],
  [0.70, 570],
  [0.80, 450],
  [0.90, 360],
  [1.00, 300],
  [1.10, 240],
  [1.20, 210],
  [1.30, 180],
  [1.40, 150],
  [1.50, 120],
  [1.60, 45],
];

const PO2_MIN = 0.5;
const PO2_MAX = 1.6;

export function noaaLimit(po2: number): number | null {
  if (po2 < PO2_MIN) return null;
  if (po2 > PO2_MAX) return 0;
  for (let i = 0; i < NOAA_TABLE.length - 1; i++) {
    const [p1, l1] = NOAA_TABLE[i]!;
    const [p2, l2] = NOAA_TABLE[i + 1]!;
    if (po2 >= p1 && po2 <= p2) {
      const frac = (po2 - p1) / (p2 - p1);
      return l1 + (l2 - l1) * frac;
    }
  }
  return null;
}

export function cnsAtConstantPO2(po2: number, durationMin: number): number {
  if (durationMin <= 0) return 0;
  const limit = noaaLimit(po2);
  if (limit === null) return 0;
  if (limit === 0) return Infinity;
  return (durationMin / limit) * 100;
}

export function cnsLinearSegment(
  startDepth: number,
  endDepth: number,
  durationMin: number,
  gas: GasMix,
): number {
  if (durationMin <= 0) return 0;
  const STEP = 0.1;
  let total = 0;
  let t = 0;
  while (t < durationMin) {
    const dt = Math.min(STEP, durationMin - t);
    const frac = (t + dt / 2) / durationMin;
    const depth = startDepth + (endDepth - startDepth) * frac;
    const po2 = depthToAmbient(depth) * gas.fO2;
    total += cnsAtConstantPO2(po2, dt);
    t += dt;
  }
  return total;
}
